"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCounterData = exports.parseCounterValue = exports.getNewMaxQuantity = exports.findShoppingBagItem = void 0;
var _constants = require("./constants");
const findShoppingBagItem = ({
  productCode,
  shoppingBagItems
}) => shoppingBagItems.find(({
  itemCode
}) => itemCode === productCode);
exports.findShoppingBagItem = findShoppingBagItem;
const parseCounterValue = counterValue => {
  const value = Number(counterValue);
  if (Number.isInteger(value) && value >= _constants.COUNTER_MIN_VALUE) {
    return value;
  }
  return undefined;
};
exports.parseCounterValue = parseCounterValue;
const getNewMaxQuantity = ({
  maxProductQuantity,
  item
}) => {
  const newMaxQuantity = Math.min(maxProductQuantity, item?.maxQuantity ?? _constants.DEFAULT_COUNTER_MAX_VALUE) - (item?.requestedQuantity ?? 0);
  return Math.max(newMaxQuantity, 0);
};
exports.getNewMaxQuantity = getNewMaxQuantity;
const updateCounterData = ({
  counterValue,
  maxProductQuantity,
  shouldSetInitialMaxQuantity,
  item,
  setCounterValue,
  setDisabled,
  setInitialMaxQuantity,
  setMaxQuantity
}) => {
  const newMaxQuantity = getNewMaxQuantity({
    maxProductQuantity,
    item
  });
  if (shouldSetInitialMaxQuantity) {
    setInitialMaxQuantity(newMaxQuantity);
  }
  setMaxQuantity(newMaxQuantity);
  setDisabled(newMaxQuantity === 0);
  const quantity = parseCounterValue(counterValue);
  if (quantity != null && quantity > newMaxQuantity) {
    setCounterValue(newMaxQuantity);
  }
};
exports.updateCounterData = updateCounterData;
//# sourceMappingURL=utils.js.map